import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { SearchWithPagination, SearchWithStatus, Status } from "../types";

export type LocalityByIdSearch = SearchWithStatus & SearchWithPagination & { name?: string };

export const Route = createFileRoute("/updates/regions/$regionId/localities/$localityId")({
  validateSearch(search: Record<string, unknown>): LocalityByIdSearch {
    return {
      status: (search?.status as Status) || "all",
      pageSize: search.pageSize as number,
      currentPage: search.currentPage as number,
      name: search.name as string
    };
  },

  beforeLoad({ params }) {
    return { pageName: params.localityId };
  },

  component: lazyRouteComponent(
    () => import("src/app/pages/updates/localityLocations/UpdatesLocalityLocationsPage")
  )
});
